import React from 'react';
import { TrackingPropsInterface } from '@marriott/mi-ui-library';

export enum ACarouselArrowDirection {
  Right = 'Right',
  Left = 'Left',
}

export enum ACarouselArrowDEFAULT_I18N {
  next = 'Next',
  previous = 'Previous',
}

export interface ACarouselArrowI18nProviderProps {
  next?: string;
  previous?: string;
}

export interface ACarouselArrowProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  direction?: ACarouselArrowDirection;
  disabled?: boolean;
  transparent?: boolean;
  trackingProperties?: TrackingPropsInterface;
  i18nProperties?: ACarouselArrowI18nProviderProps;
}
